
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"19","height":"19","viewBox":"0 0 19 19"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"stroke":"#fff","stroke-linecap":"round","stroke-linejoin":"round","stroke-width":"1.5","data-name":"vuesax/twotone/data-2"}},[_c('path',{attrs:{"d":"M5.541 6.333H3.166A1.588 1.588 0 011.583 4.75V3.166a1.588 1.588 0 011.583-1.583h2.375a1.588 1.588 0 011.584 1.583V4.75a1.588 1.588 0 01-1.584 1.583z","fill":"none"}}),_c('path',{attrs:{"data-name":"Vector","d":"M16.466 5.542h-2.85a.953.953 0 01-.95-.95V3.325a.953.953 0 01.95-.95h2.85a.953.953 0 01.95.95v1.267a.953.953 0 01-.95.95zM16.466 11.479h-2.85a.953.953 0 01-.95-.95V9.262a.953.953 0 01.95-.95h2.85a.953.953 0 01.95.95v1.267a.953.953 0 01-.95.95z","fill":"none"}}),_c('g',{attrs:{"data-name":"Group 127","opacity":".4"}},[_c('path',{attrs:{"data-name":"Vector","d":"M7.125 3.958h5.542M9.896 3.958v10.291a1.588 1.588 0 001.583 1.583h1.188","fill":"none"}}),_c('path',{attrs:{"data-name":"Vector","d":"M9.896 9.895h2.771","fill":"#fff"}})]),_c('path',{attrs:{"data-name":"Vector","d":"M16.466 17.417h-2.85a.953.953 0 01-.95-.95V15.2a.953.953 0 01.95-.95h2.85a.953.953 0 01.95.95v1.267a.953.953 0 01-.95.95z","fill":"none"}})])])
          )
        }
      }
    